const wallet = {
  connect: "Connect Wallet",
  greeting: "Hello MetaWarrior!",
  "connect.require.title": "Wallet Required",
  "connect.require.remarks": "Connect with your BSC Wallet to begin",
};
export default wallet;
